// dropdown.ts
export abstract class Dropdown<T> {
    protected btn: HTMLButtonElement;
    protected menu: HTMLElement;
    protected label: HTMLLabelElement;

    constructor(btnId: string, menuId: string, labelId: string) {
        this.btn = document.getElementById(btnId) as HTMLButtonElement;
        this.menu = document.getElementById(menuId) as HTMLElement;
        this.label = document.getElementById(labelId) as HTMLLabelElement;

        this.init();
    }

    protected init() {
        this.btn.addEventListener('click', (e) => {
            e.stopPropagation();
            this.toggle();
        });

        // Закрытие при клике вне
        document.addEventListener('click', (e) => {
            if (!this.menu.contains(e.target as Node) && !this.btn.contains(e.target as Node)) {
                this.close();
            }
        });
    }

    open() {
        this.btn.classList.add('open');
        this.menu.classList.add('open');
        this.onOpen();
    }

    close() {
        this.btn.classList.remove('open');
        this.menu.classList.remove('open');
        this.onClose();
    }

    toggle() {
        if (this.menu.classList.contains('open')) this.close();
        else this.open();
    }

    // Абстрактные методы для конкретных dropdown
    protected abstract onOpen(): void;
    protected abstract onClose(): void;
}